// src/modules/auth/api.ts
import { axiosPublic } from "@/modules/common/api";
import { LoginCredentials } from "@/modules/auth/types";

export async function getNewAccessToken(refresh_token: string) {
  const data = {
    refresh_token: refresh_token,
  };
  const res = await axiosPublic.post(`/api/v1/auth/token/refresh/`, data);
  return res;
}
